import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import React, { useContext } from 'react';
import { TranslationContext } from "../../../context/translations/translations-context";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";

export default function CssfDiplomasSection() {

    const { translations, formatDate } = useContext( TranslationContext );
    const { isAnonymous } = useResumeProperties();
    const { diplomas } = useResumeDocumentSection();

    return (
        <>
            <MDBRow>
                <MDBCol md="3" className="header-cv" style={ {
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "end",
                    color: "#009999",
                    fontSize: "14px"
                } }>
                    <span className="fw-bold" style={ { textAlign: "end" } }>
                        DIPLÔMES/CERTIFICATIONS
                    </span>
                </MDBCol>
                <MDBCol md="9" className="text-start" style={ { display: "flex", alignItems: "end" } }>
                    <hr style={ {
                        width: "95%",
                        margin: "0px",
                        height: "8px",
                        color: "#009999",
                        marginBottom: "8px",
                        opacity: "1"
                    } }/>
                </MDBCol>
            </MDBRow>
            { diplomas
                ?.sort( ( a, b ) => a.order - b.order )
                .map( ( diploma, index ) => (
                    diploma && diploma.schoolName && (
                        <React.Fragment key={ index }>
                            <MDBRow style={ { marginTop: "10px" } }>
                                <MDBCol md="3" className="header-cv" style={ {
                                    display: "flex",
                                    alignItems: "start",
                                    justifyContent: "end",
                                    color: "#009999",
                                    fontSize: "14px",
                                    fontFamily: "Verdana, sans-serif"
                                } }>
                                    { ( diploma.from || diploma.to || diploma.isCurrent ) && (
                                        <p className="text-end" style={ { fontSize: "14px" } }>
                                            { diploma.from ? formatDate( diploma.from, true ) : "" }
                                            { diploma.from && ( diploma.to || diploma.isCurrent )
                                                ? " - "
                                                : "" }
                                            { diploma.isCurrent
                                                ? translations.pdf.isCurrentLabel
                                                : ( diploma.to ? formatDate( diploma.to, true ) : "" ) }
                                        </p>
                                    ) }
                                </MDBCol>
                                <MDBCol md="9" className="text-start" style={ {
                                    display: "flex",
                                    alignItems: "start",
                                    flexDirection: "column",
                                    justifyContent: "start"
                                } }>
                                    <p className="text-end" style={ {
                                        fontSize: "14px",
                                        marginBottom: "2px",
                                        fontFamily: "Verdana, sans-serif"
                                    } }>{ diploma.intitule }</p>
                                    <div className="d-flex align-items-center gap-2">
                                        <p className="text-end" style={ { fontSize: "12px", fontFamily: "Verdana, sans-serif" } }>
                                            { isAnonymous && diploma.schoolName
                                                ? translations.pdf.diplomasSchoolLabel
                                                : diploma.schoolName }
                                        </p>
                                    </div>
                                </MDBCol>
                            </MDBRow>
                        </React.Fragment>
                    )
                ) )
            }
        </>
    );
}

